import {React, useEffect} from "react";
import HeadingSection from '../components/contact/HeadingSection';
import ContactInfo from '../components/contact/ContactInfo';
import ContactForm from '../components/contact/ContactForm';

export default function Contact() {
  useEffect(() => {
    const scriptId = 'recaptcha-script';

    // Only add if not already present
    if (!document.getElementById("recaptcha-script")) {
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`;
      script.async = true;
      script.id = "recaptcha-script";
      document.head.appendChild(script);
    }

    return () => {
        const mainScript = document.getElementById("g-recaptcha-script");
        if (mainScript) mainScript.remove();

        const secondaryScripts = document.querySelectorAll('script[src*="gstatic.com/recaptcha"]');
        secondaryScripts.forEach(s => s.remove());

        const script = document.getElementById(scriptId);
        if (script) script.remove();
        
        // Remove the badge that Google injects into the body
        const badge = document.querySelector('.grecaptcha-badge');
        if (badge) badge.remove();
        
        // Clean the window object to prevent "client exists" errors on re-entry
        delete window.grecaptcha;
    };
  }, []);

  return (
    <section>
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/dist/tabler-icons.min.css"
      />
      <div className="w-full bg-gray-50 min-h-[screen]">
        <HeadingSection />
        <main className="px-5 py-20 w-full bg-white max-sm:py-16">
          <div className="flex gap-20 mx-auto max-w-[1200px] max-md:flex-col max-md:gap-16">
            <ContactInfo />
            <ContactForm />
          </div>
        </main>
      </div>
    </section>
  );
}
